import { NeighborhoodMapProps } from "./types";

type OptionalPropertyOf<T extends object> = Exclude<
  {
    [K in keyof T]: T extends Record<K, T[K]> ? never : K;
  }[keyof T],
  undefined
>;

const defaultState: Pick<
  NeighborhoodMapProps["options"],
  OptionalPropertyOf<NeighborhoodMapProps["options"]>
> = {
  zoom: 15,
  pitch: 0,
  bearing: 0,
  cooperativeGestures: true,
  mapProvider: { name: "maptiler" },
  hideAttribution: false,
};

export default defaultState;
